import styled from '@emotion/styled';
import { Table, TablePaginationConfig } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MISC } from '../../../constants/define/translation';
import { ExternalToolRecord } from '../../../repository/mytm/external-tool/externalToolRepository';
import { appStyles } from '../../../styles';
import { CommonColumn, IndexColumn, UrlColumn } from '../shared-column';
import { ExternalActionColumn } from './column';

interface ExternalToolsTableProps {
  records: ExternalToolRecord[];
  loading?: boolean;
  className?: string;
  pagination?: TablePaginationConfig;
  onOpenModal: () => void;
  setCurrentRecord: (record: ExternalToolRecord) => void;
  onRefresh: () => void;
  onSetLoading: (loading: boolean) => void;
}

const { Column } = Table;
export const ExternalToolsTable = (props: ExternalToolsTableProps) => {
  const { t } = useTranslation(MISC);
  const { records, pagination } = props;

  return (
    <>
      <StyledTable
        dataSource={records}
        loading={props.loading}
        className={props.className}
        rowKey="index"
        pagination={pagination}
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={32}
          dataIndex="index"
          key="index"
          render={(value, record: any) => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.name')}
          align="left"
          dataIndex="name"
          key="name"
          render={(value, record: any) => <CommonColumn value={value} />}
        />
        <Column
          title={t('table.title.toolUrl')}
          align="left"
          dataIndex="toolUrl"
          key="toolUrl"
          render={(value, record: any) => <UrlColumn value={value} />}
        />
        <Column
          title={t('table.title.action')}
          align="left"
          width={62}
          render={(value, record: any) => <ExternalActionColumn record={record} {...props} />}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .ant-pagination-item a {
    line-height: 30px;
  }

  & th.action-home {
    text-align: center !important;
  }
`;
